import { render, staticRenderFns } from "./homework.vue?vue&type=template&id=5499fc96&scoped=true"
import script from "./homework.vue?vue&type=script&lang=js"
export * from "./homework.vue?vue&type=script&lang=js"
import style0 from "./homework.vue?vue&type=style&index=0&id=5499fc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499fc96",
  null
  
)

export default component.exports